<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="备注名称：">
                <el-input v-model.trim="searchForm.remark" placeholder="支持模糊搜索" @keyup.enter.native="getImportRecordListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.agentName" placeholder="支持模糊搜索" @keyup.enter.native="getImportRecordListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="池组名称：">
                <el-input v-model.trim="searchForm.poolName" placeholder="支持模糊搜索" @keyup.enter.native="getImportRecordListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getImportRecordListHandle" plain icon="el-icon-search">搜索查询</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="showManyCardImport()">批量导入</el-button>
                <el-button type="success" plain icon="el-icon-download" class="onlyBtn" @click="showOneCardImport12">粘贴导入</el-button>
                <el-button type="danger" class="onlyBtn" plain  @click="showImportApply">批量删除卡板</el-button>
            </el-form-item>
        </el-form>
        <p style="color: red;">备注：注销无用的卡板请及时删除，避免影响轮询效率，以及误算停机保号费。</p>
        
        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }">
            <el-table-column prop="remark" label="导入备注" align="center"></el-table-column>
            <el-table-column prop="poolName" label="词组名称" align="center"></el-table-column>
            <el-table-column prop="agentName" label="代理商名称" align="center"></el-table-column>
            <el-table-column prop="supplierName" label="供应商名称" align="center"></el-table-column>
            <el-table-column prop="totalSim" label="卡板总数" align="center"></el-table-column>
            <el-table-column prop="successSim" label="成功数" align="center"></el-table-column>
            <el-table-column prop="failSim" label="失败数" align="center"></el-table-column>
            <el-table-column prop="userName" label="导入人员" align="center"></el-table-column>
            <el-table-column prop="createTime" label="导入时间" width="140" align="center"></el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="200">
                <template slot-scope="scope">
                <el-button type="text" size="small" @click="getImportFailRecordListHandle(scope.row.id, $event)">查询详情</el-button>
                <el-button type="text" size="small" @click="exportApplyHandler(scope.row.id)">数据导出</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>
        <el-dialog :append-to-body="true" :title="title" :visible.sync="importCardVisible" width="600px" @close="cancel"
            :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <template v-if="batchImport">
                    <el-form-item label="导入Excel：" prop="uploadExcel">
                        <el-upload ref="upload" :action="uploadUrl('pool/excel/update/pool')" :headers="setHeader()" :limit="1"
                            :auto-upload="false" :data="importCardForm" :on-change="handleChange"
                            :on-success="handleSuccess">
                            <el-button slot="trigger" plain>导入Excel</el-button>
                            <el-button style="margin-left: 10px;" plain
                                @click="exportExcel('/mould/download?type=import')">导出模板</el-button>
                        </el-upload>
                    </el-form-item>
                </template>
                <template v-else-if="copyImport">
                    <p>备注：请保持复制的数量一样，否则将会导入错误. 一次性粘贴数量请保持3000左右</p>
                    <el-form-item label="ICCID：" class="iccid_textarea_range">
                        <el-input type="textarea" :rows="3" placeholder="请输入1个或多个ICCID号,多个请用逗号、空格、或者换行分隔"
                            v-model="importCardForm.iccid">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="接入号：" class="iccid_textarea_range">
                        <el-input type="textarea" :rows="3" placeholder="请输入1个或多个接入号,多个请用逗号、空格、或者换行分隔"
                            v-model="importCardForm.intoNo">
                        </el-input>
                    </el-form-item>
                </template>
                <el-form-item label="操作类型："  prop="isReward">
                    <el-radio-group v-model="importCardForm.isReward">
                        <el-radio label="0">新卡导入</el-radio>
                        <el-radio label="1">修改池组</el-radio>
                    </el-radio-group>
                </el-form-item> 

                <el-form-item label="所属池组：" prop="poolId">
                    <el-select v-model="importCardForm.poolId" filterable>
                        <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="接入备注：" class="iccid_textarea_range">
                    <el-input type="textarea" :rows="2" placeholder="请输入本次导入备注"
                            v-model="importCardForm.remark">
                    </el-input>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :append-to-body="true" title="数据详情" :visible.sync="importFailVisible" width="1000px"
            :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column prop="iccid" label="ICCID号" width="200px"></el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="stateName" label="状态"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage" :page-sizes="[10, 50, 100, 500]" :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>


        <el-dialog :append-to-body="true" title="删除池组卡板" :visible.sync="importVisible" width="600px"
            :close-on-click-modal="false">
            <p style="color: red;">备注：（1）请注意，删除卡板重新导入之后，流量会重新计费。</p>
            <p style="color: red;">（2）共享低消的卡，每个月1号为月结日，期间不建议操作数据。</p>
            <el-form :model="searchForm" label-width="120px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('pool/excel/delete/pool')" :headers="setHeader()" :limit="1"
                        :auto-upload="false" :on-success='handleSuccessSn'>
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain
                            @click="exportExcel('/mould/download?type=changeState')">导出模板（仅支持ICCID）</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="importCancel">取 消</el-button>
                <el-button type="primary" @click="importApplyHandler">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :append-to-body="true" title="提示" :visible.sync="confirmExportDialogVisible" width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportApplyHandler">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import { oneCardImport, getImportRecordList, getImportFailRecordList, oneCardImport1, oneCardImport12 } from '@/api/sim.js'
import { getSimTypeOption } from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data() {
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if (len > 0) {
                var extName = files[0].name.split('.')[1].toLowerCase();
                if (extName != 'xls' && extName != 'xlsx') {
                    return callback(new Error('请选择要导入的Excel文件'));
                } else {
                    callback();
                }
            } else {
                return callback(new Error('请选择要导入的Excel文件'))
            }
        }
        return {
            agentAccountForm: {
                name: '',
                sysUserAccountName: '',
                accountState: ''
            },
            searchForm: {
                name: '',
            },
            importCardForm: {
                iccid: '',
                iccidStart: '',
                iccidEnd: '',
                intoNoEnd: '',
                intoNo: '',
                agentId: '',
                supplierCode: '',
                poolId: '',
                cardType: '0',
                isReward: '0',
                virtualNo: ''
            },
            importCardVisible: false,
            batchImport: true,
            copyImport: false,
            batchSimsImport: false,
            importFailVisible: false,
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            currentId_fail: '',
            pkgGroup: [],
            agentListOption: [],
            branchSupplierOption: [],
            simTypeOption: [],
            title: '',
            importCardRules: {
                uploadExcel: [{ required: true, validator: checkImportFile }],
                poolId: [{ required: true, message: '请选择池组', trigger: 'change' }],
                remark: [{ required: true, message: '请选择本次导入的备注', trigger: 'change' }],
            },


            importVisible: false,

            confirmExportDialogVisible: false,
        }
    },
    methods: {
        exportApplyHandler(id) {
            var data = {
                id:id
            }
            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('export/importInfo', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    } else {
                        this.$message.error(res.data.msg);
                    }
                })
            }).catch(() => {

            });
        },

        



        handleSuccessSn(res) {
            if (res.code == 200) {
                this.importVisible = false;
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        showImportApply() {
            this.importVisible = true;
        },
        importApplyHandler() {
            this.$refs.upload.submit();
        },
        importCancel() {
            this.importVisible = false;
        },






        cancel() {
            this.batchSimsImport = false;
            this.importCardVisible = false;
            this.$refs.importCardForm.resetFields();
        },
        handleChange(file, fileList) {
            if (fileList.length > 0) {
                this.$refs.importCardForm.fields[0].clearValidate();
            }
        },
        getImportRecordListHandle($event) {
            common.resetCurrentPage(this, $event, "tbpg");
            var data = common.getRequestParams(this, "tbpg", this.searchForm);
            common.sysRequest('pool/select/sim/page', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        getImportFailRecordListHandle(id, $event) {
            this.importFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail
            }
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);
            common.sysRequest('pool/select/sim/page/info', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },
        showManyCardImport() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "批量导入";
            this.batchImport = true;
        },
        showOneCardImport() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "单卡导入";
            this.batchImport = false;
        },
        showOneCardImport1() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "号段导入";
            this.batchSimsImport = true;
            this.batchImport = false;
        },
        showOneCardImport12() {
            this.getOptionsOfSelect();
            this.importCardVisible = true;
            this.title = "复制导入";
            this.copyImport = true;
            this.batchSimsImport = false;
            this.batchImport = false;
        },
        getOptionsOfSelect() {
            common.getAgentListOptionCom(this, 'agentListOption');
            common.sysRequest('pool/select/pool/user/list', {}, 'post').then(res => {
                this.pkgGroup=res.data.data;
            })
            common.getBranchSupplierOptionCom(this, 'branchSupplierOption')
            getSimTypeOption().then(res => {
                if (res.data.code == 200) {
                    this.simTypeOption = res.data.data;
                } else {
                    this.$message.error(res.data.message);
                }
            })
        },
        sureImportCardHandle() {
            if(!this.importCardForm.remark){
                this.$message.error('请输入本次导入的备注');
                return;
            }
            this.$refs.importCardForm.validate(valid => {
                if (valid) {
                    if (this.batchImport) {
                        this.$refs.upload.submit();   //号段批量导入
                    } else {
                        var data = this.importCardForm;
                        common.sysRequest('pool/excel/update/pool/batch', data, 'post').then(res => {
                            if (res.data.code == 200) {
                                this.$message.success('导入完成！');
                                this.getImportRecordListHandle();
                                this.importCardVisible = false;
                                this.batchSimsImport = false;
                            } else {
                                this.$message.error(res.data.message);
                            }
                        })
                    }
                    
                }
            })
        },
        handleSuccess(res) {
            if (res.code == 200) {
                this.importCardVisible = false;
                this.getImportRecordListHandle();
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
        },
        handleSizeChange(val) {
            if (this.importFailVisible) {
                this.tbpg_fail.pageSize = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            } else {
                this.tbpg.pageSize = val;
                this.getImportRecordListHandle();
            }
        },
        handleCurrentChange(val) {
            if (this.importFailVisible) {
                this.tbpg_fail.currentPage = val;
                this.getImportFailRecordListHandle(this.currentId_fail);
            } else {
                this.tbpg.currentPage = val;
                this.getImportRecordListHandle();
            }
        }
    },
    created() {
        this.getImportRecordListHandle();
    }
}
</script>

<style lang="less" scoped></style>
